
            const data = {"name":"icon-minus","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M.86 16.52a.52.52 0 110-1.04h30.27a.52.52 0 110 1.04H.86z\"/>"}}
        
                module.exports = data
                